import React from "react";
import { Outlet } from "react-router-dom";
import AppShell from "./AppShell";

const Layout = ({ children }: React.PropsWithChildren) => {
  return <AppShell>{children ?? <Outlet />}</AppShell>;
};

export default Layout;
